import React from "react";
import Breadcrumbs from "../../../reusebale/breadcrumbs"
import PersonalForm from "../personal-information/personal-form";
import UploadImage from "../personal-information/upload-image";
import { useSelector } from "react-redux"

const PersonalInfo = ({ onBack,clases }) => {
  const { loginSuccess, userCompleteProfile } = useSelector((state) => state.auth)
  return (
    <div className={`w-full ${clases}`}>
      <Breadcrumbs content={`${loginSuccess?.user?.firstName} ${loginSuccess?.user?.lastName}`} subheading='My Account' onBack={onBack} />
      <div className="flex justify-between mt-8">
        <div className="w-[100%]">
          <PersonalForm />
        </div>
        {/* <div className="w-[34%]">
          <UploadImage
            imagePath=''
            imageTitle="Profile Image"
          />
        </div> */}
      </div>
    </div>
  );
};

export default PersonalInfo;
